// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xGwa","questions":"styles_questions__2MIl-","footer":"styles_footer__KmLgi"};